import jQuery from 'jquery';

export const lightboxConfig = {
    onClose(lb) {
        const lightbox = lb;

        if (lightbox.storage.predictorFrame) {
            lightbox.storage.predictorFrame.contentWindow.location.reload();
        }
    },
    onInit(lb) {
        const lightbox = lb;

        lightbox.storage.predictorFrame = lightbox.HTMLContainer
            .querySelector('.js-RC-predictor__frame');
        lightbox.storage.predictorLabel = lightbox.HTMLContainer
            .querySelector('.js-RC-predictor__label');
        jQuery(window).on('RC.CLOSE_PREDICTOR', lightbox.close.bind(lightbox));
    }
};



// WEBPACK FOOTER //
// ./lib/js/modules/lightbox/lightbox.config.js